





import Vue from 'vue'
export default Vue.extend({
  props: {
    isShow: Boolean,
    isError: Boolean
  }
})
